/* This file is autogenerated, see readme.md for instructions */
import NegationSvgIcon from '@bloomreach/banana-theme/icons/negation.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const NegationIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <NegationSvgIcon />
    </Icon>
  );
});

NegationIcon.displayName = 'NegationIcon';

export default NegationIcon;
